import React from "react";
import { Button, styled } from "@material-ui/core";
import { PRODUCT_DETAILS_ACTIONS_HEIGHT } from "../ProductDetails/components/Actions/styles";

export const AddToCartButton = styled(Button)(({ theme }) => ({
  height: PRODUCT_DETAILS_ACTIONS_HEIGHT,
  flex: 1,
  borderTopLeftRadius: 0,
  borderBottomLeftRadius: 0,
  whiteSpace: "nowrap",
  "&.Mui-disabled": {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    "&:hover": {
      backgroundColor: theme.palette.common.black
    }
  }
}));

export const QuantitySelector = styled("div")(({ theme }) => ({
  fontFamily: "Roobert",
  flex: 1,
  height: PRODUCT_DETAILS_ACTIONS_HEIGHT,
  borderTopLeftRadius: PRODUCT_DETAILS_ACTIONS_HEIGHT,
  borderBottomLeftRadius: PRODUCT_DETAILS_ACTIONS_HEIGHT,
  background: theme.palette.common.white,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontSize: "2rem",
  lineHeight: "2.4rem",
  fontWeight: 500,
  userSelect: "none"
}));

export const QuantityButton = styled(Button)(({ theme }) => ({
  fontSize: "2.7rem",
  lineHeight: 1,
  userSelect: "none",
  padding: 0,
  width: "34px",
  height: "34px",
  minWidth: "unset",
  minHeight: "unset",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  "&.disabled": {
    color: theme.palette.text.secondary
  },
  "& .MuiButton-label": {
    width: "100%",
    height: "100%",
    lineHeight: 1,
    transform: "translate(1px, -1px)"
  }
}));

export const QuantityValue = styled("span")(({ theme }) => ({
  fontSize: "2.1rem",
  lineHeight: "2.4rem",
  marginRight: theme.spacing(2),
  marginLeft: theme.spacing(2),
  userSelect: "none"
}));
